import { isBrowser as n } from "./ghl-ui.es1132.js";
let t;
const d = () => {
  if (!n)
    return !0;
  if (t === void 0) {
    const e = document.createElement("div");
    e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e);
    const r = e.scrollHeight === 1;
    return document.body.removeChild(e), t = r;
  }
  return t;
};
export {
  d as ensureSupportFlexGap
};
